<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { getAccess } from "@/api/account";

export default {
  name: "App",
  components: {},
  created() {
    this.$store.dispatch("app/getConfig");
  },

  watch: {
    // "$route.query.code"(){
    //     this.init();
    // }
  },
  computed: {
    ...mapGetters({
      channel: "app/channel",
    }),
  },
  methods: {},
};
</script>

<style></style>
